import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
export class GroupQuestionStylingModel extends CoreStylingModel {
/**
 * Styling for the group question table
 */
table?: StylingModel;
/**
 * Styling for the group question content
 */
content?: StylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function GroupQuestionStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the group question table
 * @type {?}
 */
GroupQuestionStylingModel.prototype.table;
/**
 * Styling for the group question content
 * @type {?}
 */
GroupQuestionStylingModel.prototype.content;
}

